import * as routerActions from 'mb-app-common/store/actions/router'

export default function(history){

	return next => action => {
		if(action.type === routerActions.ROUTER_PUSH){
			history.push(`/${action.name}`)
			// prevent default handler
		}else{
			if(action.type === routerActions.ROUTER_POP){
				history.goBack()
				// prevent default handler
			}else{
				return next(action)
			}
		}
	}
}



// WEBPACK FOOTER //
// ./client/store/middleware/app-router-shim.js